import navigation from '@/navigation'
import { canOpenTarget } from '@/navigation/access'

/**
 * The Android app's tabs (AppTabBar), each for whoever may open its page; every other page is on the "More" tab
 * (AppMore). badge names the navigation store's unread count.
 */
const TABS = [
    { route: 'mail.inbox', prefix: 'mail.', icon: 'pi pi-envelope', label: 'mail.mail', badge: 'mailUnreadCount' },
    { route: 'chat.index', prefix: 'chat.', icon: 'pi pi-comments', label: 'chat.chat', badge: 'chatUnreadCount' },
    { route: 'calendar.index', prefix: 'calendar.', icon: 'pi pi-calendar', label: 'calendar.calendar' },
    { route: 'contacts.index', prefix: 'contacts.', icon: 'pi pi-users', label: 'contacts.contacts' },
]

export function appTabs(user) {
    return TABS.filter((tab) => canOpenTarget(navigation, user, tab.route))
}

/** Where the app opens: its first tab, or "More" for someone who has none of them. */
export function appStartRoute(user) {
    const first = appTabs(user)[0]
    return { name: first ? first.route : 'app.more' }
}
